import {classes} from './AsideLoader.st.css';
import React from 'react';
import {SkeletonSection} from '../../Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export enum AsideLoaderDataHooks {
  Loader = 'AsideLoaderDataHooks.Loader',
  OldLoader = 'AsideLoaderDataHooks.OldLoader',
}

export const AsideLoader = () => {
  return (
    <SkeletonSection dataHook={AsideLoaderDataHooks.Loader}>
      <SkeletonRow>
        <SkeletonLineWrapper className={classes.skeleton} />
      </SkeletonRow>
    </SkeletonSection>
  );
};
